export const BLOG_HEADER_TOTAL_RESULTS = 'Wix-SocialBlog-TotalResults';
export const BLOG_HEADER_CURSOR = 'wix-socialblog-cursor';
//# sourceMappingURL=headers.js.map